import { locales, type Locale } from 'contexts/LocaleContext/locales';

export const getTextDirection = (locale: Locale) =>
  locales[locale]?.rtl ? 'rtl' : 'ltr';
